import React from 'react'
import Spacer from '../components/general/Spacer'
import Video from '../components/Video'
import MediaRender from '../components/general/MediaRender'

function Media({ options }) {
    switch (options.type) {
    case 'video':
        return (
            <Video
                videoSrcURL={options.videoSrcURL}
                videoTitle={options.videoTitle}
                height={options.videoHeight || '656px'}
            />
        )
    default: // image
        return (
            <Spacer spacing={options.spacing} elementId={options?.elementId ?? false}>
                <MediaRender file={options.media.set && options.media.set[0]} alt={options.caption || ''} options={options} />
            </Spacer>
        )
    }
}

export default Media
